<template>
  <div class="col-lg-8 offset-lg-2 page">
    <div class="row">
      <diagnosis-filter :arrayToFilter="allDiagnoses" :type="type"
                        v-on:update-keywords="updateKeywords"
                        v-on:filter-diagnoses="updateFilterResults">
      </diagnosis-filter>
      <diagnosis-sort></diagnosis-sort>
    </div>

    <diagnosis-detail :keywords="keywords"
                      :diagnoses="filteredDiagnoses ? filteredDiagnoses : allDiagnoses">
    </diagnosis-detail>

  </div>
</template>

<script>
  import { getAllDiagnosis } from '@/data/getters.js';
  import {mapGetters} from 'vuex';
  import DiagnosisDetail from './DiagnosisDetail';
  import FilterPage from '../_partials/filter/FilterPage';
  import SortPage from '../_partials/sort/SortPage';

  export default {
    name: "DiagnosisPage",
    components: {
      'diagnosis-filter': FilterPage,
      'diagnosis-sort': SortPage,
      'diagnosis-detail': DiagnosisDetail,
    },
    data() {
      return {
        filteredDiagnoses: null,
        keywords: [],
        type: 'DIAGNOSIS',
      }
    },
    computed: {
      ...mapGetters('login', {
        allData: 'getAllData',
      }),
      allDiagnoses: function () {
        return getAllDiagnosis(this.allData);
      }
    },
    methods: {
      updateFilterResults(data) {
        this.filteredDiagnoses = data;
      },
      updateKeywords(data) {
        this.keywords = data;
      },
    }
  }
</script>

<style scoped lang="scss">
  .page {
    max-width: 800px;
  }
</style>